<template>
  <IdentifyDblSelect previous-page-id="en007" next-page-id="en009">
    <template #wizard>
      <WizardGroup>
        <MainWizard :active-index="2" type="en2"></MainWizard>
        <SubWizard :active-index="1" type="upload"></SubWizard>
      </WizardGroup>
    </template>
  </IdentifyDblSelect>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifyDblSelect from "@/components/fileupload/IdentifyDblSelect";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import SubWizard from "@/components/wizard/SubWizard";

export default {
  name: "En008",
  components: {
    SubWizard,
    MainWizard,
    WizardGroup,
    IdentifyDblSelect,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
};
</script>

<style lang="scss" scoped></style>
